var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00039 1.48828C4.85237 1.48828 1.48926 4.85139 1.48926 8.99941C1.48926 13.1474 4.85237 16.5105 9.00039 16.5105C13.1484 16.5105 16.5115 13.1474 16.5115 8.99941C16.5115 4.85139 13.1484 1.48828 9.00039 1.48828ZM12.6014 6.90819L8.21986 11.9156C8.08904 12.0521 7.93882 12.1291 7.74854 12.1291C7.58266 12.1291 7.42305 12.0633 7.306 11.9457L5.42822 10.0679C5.30617 9.94582 5.24482 9.78558 5.24482 9.62534C5.24482 9.2936 5.50834 8.99941 5.87075 8.99941C6.03099 8.99941 6.19123 9.06013 6.31328 9.18281L7.71786 10.5874L11.6587 6.08322C11.7733 5.95302 11.9435 5.86978 12.13 5.86978C12.5081 5.86978 12.756 6.18086 12.756 6.4957C12.756 6.64593 12.7153 6.778 12.6014 6.90819Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.507392f5acd8f3a9f5e060e901eb1a85.svg";
export { ForwardRef as ReactComponent };